import warehouse from './warehouse';
import tent from './tent';

export default {
  warehouse,
  tent,
};
